type HouseCusp = { longitude?: number };

const normalize = (longitude: number) => (longitude % 360 + 360) % 360;

// Placidus cusps are bhava centers in the Vedic Chalit view. The boundary
// between two bhavas is halfway along the forward arc between their cusps.
export function getVedicBhavaHouse(
  longitude: unknown,
  cusps: Record<string | number, HouseCusp> | null | undefined,
): number | null {
  if (typeof longitude !== 'number' || !Number.isFinite(longitude) || !cusps) return null;
  const points = Array.from({ length: 12 }, (_, index) => cusps[index + 1]?.longitude);
  if (points.some((point) => typeof point !== 'number' || !Number.isFinite(point))) return null;
  const centers = points as number[];
  const boundaries = centers.map((center, index) =>
    normalize(center + normalize(centers[(index + 1) % 12] - center) / 2));
  const position = normalize(longitude);

  for (let index = 0; index < 12; index += 1) {
    const start = boundaries[(index + 11) % 12];
    const end = boundaries[index];
    if (end > start ? position >= start && position < end : position >= start || position < end) {
      return index + 1;
    }
  }
  return null;
}
